import React, { useId } from 'react';
import { useTranslation } from 'react-i18next';
import { useController, useFormContext } from 'react-hook-form';
import TagInput from '@wix/da-shared-react/pkg/TagInput';

interface Props {}

const TagsField: React.FC<Props> = () => {
  const { t } = useTranslation();
  const id = useId();
  const { control, errors } = useFormContext();

  const {
    field: { value, onChange },
  } = useController({ name: 'tags', control });
  const error = errors['tags'];

  return (
    <TagInput
      withCopy
      id={id}
      label={t('customExclusivePopup.form.tags.label')}
      value={value}
      onChange={onChange}
      noBottomSpacing
      validationResult={error && 'error'}
      details={error?.message}
    />
  );
};
TagsField.displayName = 'TagsField';

export default TagsField;
